import {useMutation, useQueryClient} from '@tanstack/react-query';
import {ReitService as reitService} from '@/services/investments';
import {ReitHolding} from "@/@types/reit.models.ts";

/**
 * Custom hook to update a REIT (Real Estate Investment Trust) holding.
 * This hook leverages `useMutation` to perform the update operation and
 * invalidates the cache for 'reit_holdings' query on a successful mutation.
 *
 * @return {UseMutationResult} A mutation object that provides methods and state
 *         for the update operation, including `mutate` to trigger the mutation
 *         and `status` to track the mutation state.
 */
export default function useUpdateReitHolding() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...updates }: Partial<ReitHolding> & { id: string }) => {
      return await reitService.updateHolding(
          {
            id,
            userId: updates.user_id,
            ...updates,
          }
      )
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['reit_holdings'] }),
  });
}